<template>
  <div class="flex items-center justify-center w-full h-full">
    <div
      ref="lottieContainer"
      style="width: 120px; height: 120px"
    />
  </div>
</template>

<script>
import lottie from "lottie-web";
export default {
  props: {
    src: { type: Object, required: true },
  },
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.lottieContainer,
      animationData: this.src,
      renderer: "svg",
      loop: true,
      autoplay: true,
    });
  },
};
</script>
